import { s as b, r as w, a as T, b as K, c as C, g as S, p as A } from "./tokens-C4KyVSzL.js";
import { A as $, I as G, R as V, S as X, d as q, e as J, f as Q } from "./tokens-C4KyVSzL.js";
import x from "keycloak-js";
import { h as P } from "./oauth-callback-D1dy1GrA.js";
const U = 60 * 1e3, L = 300;
async function M(n) {
  if (typeof n != "object" || !n)
    return !1;
  if ("error" in n && n.error === "invalid_grant")
    return !0;
  if (!("response" in n) || !(n.response instanceof Response) || n.response.status !== 400)
    return !1;
  try {
    const r = await n.response.clone().json();
    return typeof r == "object" && !!r && "error" in r && r.error === "invalid_grant";
  } catch {
    return !1;
  }
}
function D(n) {
  var g;
  b(n.appStorageKey);
  const r = {
    realm: n.realm,
    clientId: n.clientId,
    url: n.url
  }, t = new x(r), p = (g = n.scope) != null ? g : "openid profile email";
  let i = null, a = null, c = !1, d = null, l = null;
  const m = () => {
    T(t.token, t.refreshToken, t.idToken);
  }, v = () => {
    d && (clearTimeout(d), d = null);
  }, u = () => {
    c = !1, v(), l && (document.removeEventListener("visibilitychange", l), l = null);
  }, f = () => a || (u(), w(), a = t.login().catch((e) => {
    throw a = null, e;
  }), a), I = () => {
    var s, R;
    const e = (s = t.tokenParsed) == null ? void 0 : s.exp;
    if (typeof e == "number")
      return e * 1e3;
    const o = (R = t.token) != null ? R : S();
    if (!o)
      return null;
    try {
      return A(o).exp * 1e3;
    } catch {
      return null;
    }
  }, y = () => {
    if (v(), !c)
      return;
    const e = I();
    if (!e)
      return;
    const o = Math.max(0, e - Date.now() - U);
    d = setTimeout(() => {
      k().then((s) => {
        s || u();
      }).catch(() => {
      });
    }, o);
  }, _ = async () => {
    try {
      await t.updateToken(L);
      const { token: e, refreshToken: o, idToken: s } = t;
      if (!e)
        throw new Error("Token is undefined after updateToken");
      return T(e, o, s), c && y(), e;
    } catch (e) {
      if (await M(e)) {
        await f();
        return;
      }
      throw console.error(e), e;
    }
  }, k = () => i || (i = _().finally(() => {
    i = null;
  }), i), h = () => {
    u(), c = !0, y(), l = () => {
      document.visibilityState !== "visible" || !c || k().then((e) => {
        e || u();
      }).catch(() => {
      });
    }, document.addEventListener("visibilitychange", l);
  }, E = () => P() ? (w(), {}) : {
    token: S() || void 0,
    refreshToken: C() || void 0,
    idToken: K() || void 0
  };
  return {
    init: async () => {
      if (t.didInitialize)
        return;
      const e = E();
      await t.init({
        flow: "standard",
        scope: p,
        token: e.token,
        refreshToken: e.refreshToken,
        idToken: e.idToken,
        messageReceiveTimeout: n.messageReceiveTimeout,
        checkLoginIframe: !1
      }), t.authenticated && t.token && (m(), h());
    },
    initWithCheckSso: async () => {
      var e;
      if (!t.didInitialize) {
        const o = E();
        await t.init({
          flow: "standard",
          onLoad: "check-sso",
          silentCheckSsoRedirectUri: (e = n.silentCheckSsoRedirectUri) != null ? e : `${window.location.origin}/silent-check-sso.html`,
          pkceMethod: "S256",
          scope: p,
          token: o.token,
          refreshToken: o.refreshToken,
          idToken: o.idToken,
          messageReceiveTimeout: n.messageReceiveTimeout,
          checkLoginIframe: !1
        });
      }
      if (t.authenticated && t.token)
        return m(), h(), t.authenticated;
      if (t.refreshToken) {
        const o = await k();
        return T(o, t.refreshToken, t.idToken), t.authenticated && o && h(), t.authenticated || !1;
      }
      return await f(), !1;
    },
    updateToken: k,
    login: f,
    logout: async () => {
      var e;
      u(), await t.logout({
        redirectUri: (e = n.postLogoutRedirectUri) != null ? e : `${window.location.origin}/logoff`
      });
    },
    getUserInfo: async (e) => e()
  };
}
export {
  $ as ACCESS_TOKEN_KEY,
  G as ID_TOKEN_KEY,
  V as REFRESH_TOKEN_KEY,
  X as SUB_KEY,
  D as createAuthClient,
  q as decodeToken,
  S as getAccessToken,
  K as getIdToken,
  J as getIsTokenExpired,
  C as getRefreshToken,
  Q as getSub,
  P as hasOAuthCallbackParams,
  A as parseToken,
  w as removeTokens,
  b as setTokenStorageAppKey,
  T as setTokens
};
//# sourceMappingURL=core.es.js.map
